<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<reporting-sidenav></reporting-sidenav>

			<div id="content" class="app-content box-shadow-3">
				<!-- Optional navbar at top of page -->
				<div class="navbar navbar-light bg-light b-b">
					<a class="navbar-brand">Traffic Dashboard</a>
				</div>

				<div class="content-main">
					<div class="padding">
						<div class="row">
							<div class="col-12 col-xl-4">
								<traffic-dash-completion />
							</div>
							<div class="col-12 col-xl-4">
								<traffic-dash-counts />
							</div>
							<div class="col-12 col-xl-4">
								<traffic-dash-assessments />
							</div>

							<div class="col-12">
								<traffic-dash-logins />
							</div>

							<div class="col-12">
								<traffic-dash-user-activity :user="user" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content-main {
	background-color: #f3f6f9;
}
</style>

<script>
import $ from "jquery";
import _ from "lodash";
import notie from "@/services/NotieService";
import store from "@/services/Store";

import TrafficDashCompletion from "@/components/TrafficDashboard/TrafficDashCompletion";
import TrafficDashCounts from "@/components/TrafficDashboard/TrafficDashCounts";
import TrafficDashAssessments from "@/components/TrafficDashboard/TrafficDashAssessments";
import TrafficDashLogins from "@/components/TrafficDashboard/TrafficDashLogins";
import TrafficDashUserActivity from "@/components/TrafficDashboard/TrafficDashUserActivity";

export default {
	name: "TrafficDashboard",
	props: ["user"],
	data() {
		return {
			teams: [],
			selectedTeam: null
		};
	},
	components: {
		TrafficDashCompletion,
		TrafficDashCounts,
		TrafficDashAssessments,
		TrafficDashLogins,
		TrafficDashUserActivity
	},
	created() {},
	mounted() {},
	methods: {}
};
</script>





// WEBPACK FOOTER //
// src/vues/Landing/TrafficDashboard.vue